/**
 * <filtering-tabs>
 *
 * Intercepts clicks on the All / Sets / Individual Components links
 * and delegates to the section's <facets-form-component> so the
 * collection grid updates via the Section Rendering API (no full reload).
 *
 * Falls back to native navigation if facets-form-component is not present
 * (e.g. when the filters block has been disabled).
 */
class FilteringTabs extends HTMLElement {
  connectedCallback() {
    this.addEventListener('click', this.#onClick);
  }

  disconnectedCallback() {
    this.removeEventListener('click', this.#onClick);
  }

  /** @param {MouseEvent} event */
  #onClick = (event) => {
    if (!(event.target instanceof Element)) return;
    const link = event.target.closest('a.filtering-tab');
    if (!(link instanceof HTMLAnchorElement)) return;

    // Honor modifier keys (open in new tab, etc.)
    if (event.metaKey || event.ctrlKey || event.shiftKey || event.altKey || event.button !== 0) return;

    const url = link.getAttribute('href');
    if (!url) return;

    const section = this.closest('.shopify-section');
    const facetsForm = section?.querySelector('facets-form-component');
    if (!facetsForm || typeof facetsForm.updateFiltersByURL !== 'function') return;

    event.preventDefault();
    facetsForm.updateFiltersByURL(url);
  };
}

if (!customElements.get('filtering-tabs')) {
  customElements.define('filtering-tabs', FilteringTabs);
}
